import { serviceRouteConstants } from "@/Constants/routingConstants";
import store from "@/store";

import { post, postFormData } from ".";
import { getSystemAllRequests, systemAllRequests } from "../utilities/utils";

/**
 * Get invited candidates by making a POST request to the client.invited_candidate_list route with the provided data.
 *
 * @param {Object} data - The data to be sent in the POST request
 * @return {Promise} A promise that resolves to the result of the POST request
 */
export const _getInvitedCandidates = async (data) => {
  var invitedDateFrom = data.invitedDateFrom;
  var invitedDateTo = data.invitedDateTo;
  var registeredDateFrom = data.registeredDateFrom;
  var registeredDateTo = data.registeredDateTo;
  var sessionType = data.sessionType;
  var candidateType = data.candidateType;
  if (invitedDateFrom && invitedDateFrom !== "") {
    invitedDateFrom = invitedDateFrom.split("/").reverse().join("-");
  }

  if (invitedDateTo && invitedDateTo !== "") {
    invitedDateTo = invitedDateTo.split("/").reverse().join("-");
  }

  if (registeredDateFrom && registeredDateFrom !== "") {
    registeredDateFrom = registeredDateFrom.split("/").reverse().join("-");
  }

  if (registeredDateTo && registeredDateTo !== "") {
    registeredDateTo = registeredDateTo.split("/").reverse().join("-");
  }

  if (sessionType && sessionType !== "") {
    sessionType = sessionType.join(",");
  }

  if (candidateType && candidateType !== "") {
    candidateType = candidateType.join(",");
  }

  let postData = {
    candidate_type: candidateType,
    session_type: sessionType,
    candidate_reference_no: data.candidateReferenceNo,
    candidate_license_no: data.candidateLicenseNo,
    candidate_name: data.candidateName,
    candidate_compliance_status: data.complianceStatus,
    candidate_role: data.candidateRole,
    candidate_postcode: data.candidatePostcode,
    invited_date_from: invitedDateFrom,
    invited_date_to: invitedDateTo,
    registered_date_from: registeredDateFrom,
    registered_date_to: registeredDateTo,
    miles: data.miles,
    search: data.search,
    page: data.currentPage,
    actioned_by_id: data.actionedById,
    actioned_by_type: data.actionedByType,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };

  // console.log("")

  systemAllRequests({
    request: postData,
    page: "invited",
    route: serviceRouteConstants.getCandidateList,
  });

  const request = {
    endPoint: serviceRouteConstants.getCandidateList,
    data: postData,
  };
  return await post(request);
};
/**
 * Send candidate invitation and handle invited candidate list.
 *
 * @param {Object} data - The data object containing candidate_email
 * @return {Promise} The result of the post request
 */
export const _sendCandidateInvitation = async (data) => {
  let { candidate_email } = data;
  let candidate_email_arr = candidate_email.split(","); // convert string to array
  const { invitedCandidates } = store.getState().clientCandidatesInvited; // get invited candidate list from redux store
  invitedCandidates.map((item) => {
    if (item.is_registered) {
      let index = candidate_email_arr.indexOf(item.email);
      if (index > -1) {
        candidate_email_arr.splice(index, 1);
      }
    }
  });
  data.candidate_email = candidate_email_arr.join(",");

  const postData = {
    candidate_email: data.candidate_email,
    candidate_name: data.candidate_name,
    candidate_phone: data.candidate_phone,
    again_send_mail: data.again_send_mail,
    type: data.type,
  };
  const request = {
    endPoint: serviceRouteConstants.sendCandidateInvitation,
    data: postData,
  };
  return await post(request);
};

export const _resendInvitedBankCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.resendInvitedBankCandidate,
    data: {
      invitation_ids: data.invitationIds.join(","),
    },
  };
  return await post(request);
};

export const _autoApproveBankCandidate = async (data) => {
  const { selectedCandidateIds, auto_book_status } = data;
  const request = {
    endPoint: serviceRouteConstants.autoApproveBankCandidate,
    data: {
      invitation_ids: selectedCandidateIds,
      auto_book_status: auto_book_status,
    },
  };
  return await post(request);
};

export const _removeInvitedCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.removeInvitedCandidate,
    data: data,
  };
  return await post(request);
};

export const _checkInvitedBankCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.checkInvitedBankCandidate,
    data: {
      candidate_email: data.candidateEmail,
    },
  };
  return await post(request);
};

/**
 * Asynchronously sends a POST request to import invited candidates using the provided data.
 *
 * @param {Object} data - The data to be sent in the request.
 * @return {Promise} A promise that resolves with the result of the POST request.
 */
export const _bulkImportInvitedCandidates = async (data) => {
  let formData = new FormData();
  formData.append("import_file", data.import_file);
  return postFormData(serviceRouteConstants.importCandidateResume, formData);
};
// invited

/**
 * Asynchronously shortlists candidates with the provided data.
 *
 * @param {Object} data - The data for shortlisting candidates.
 * @return {Promise} The result of the shortlisting operation.
 */
export const _shortListCandidates = async (data) => {
  let postData = getSystemAllRequests(data, "shortlist");
  //   console.log(postData);
  const request = {
    endPoint: postData.route,
    data: postData,
  };
  return await post(request);
};

/**
 * An asynchronous function to mark candidates as unsuitable.
 *
 * @param {object} data - The data to be sent in the POST request
 * @return {Promise} A promise that resolves with the response data from the POST request
 */
export const _unSuitableCandidates = async (data) => {
  let postData = getSystemAllRequests(data, "unsuitable");
  //   console.log(postData);
  const request = {
    endPoint: postData.route,
    data: postData,
  };
  return await post(request);
};
export const _removeCandidateStatus = async (data) => {
  let postData = getSystemAllRequests(data, "remove_status");
  const request = {
    endPoint: postData.route,
    data: postData,
  };
  return await post(request);
};

/**
 * Retrieves applied candidates using the provided data.
 *
 * @param {Object} data - The data to be used for retrieving applied candidates
 * @return {Promise} The result of the post request
 */
export const _getAppliedCandidates = async (data) => {
  var appliedDateFrom = data.appliedDateFrom;
  var appliedDateTo = data.appliedDateTo;
  var contractDateFrom = data.contractDateFrom;
  var contractDateTo = data.contractDateTo;
  var sessionType = data.sessionType;
  if (appliedDateFrom && appliedDateFrom !== "") {
    appliedDateFrom = appliedDateFrom.split("/").reverse().join("-");
  }

  if (appliedDateTo && appliedDateTo !== "") {
    appliedDateTo = appliedDateTo.split("/").reverse().join("-");
  }

  if (contractDateFrom && contractDateFrom !== "") {
    contractDateFrom = contractDateFrom.split("/").reverse().join("-");
  }

  if (contractDateTo && contractDateTo !== "") {
    contractDateTo = contractDateTo.split("/").reverse().join("-");
  }

  if (sessionType && sessionType !== "") {
    sessionType = sessionType.join(",");
  }

  let postData = {
    candidate_id: data.candidateId?.join(","),
    candidate_compliance_status: data.complianceStatus,
    applied_date_from: appliedDateFrom,
    applied_date_to: appliedDateTo,
    contract_date_from: contractDateFrom,
    contract_date_to: contractDateTo,
    postcode: data.candidatePostcode,
    sessionType: sessionType,
    candidate_reference_no: data.candidateReferenceNo,
    contract_reference_no: data.contractReferenceNo,
    licence_no: data.candidateLicenseNo,
    role: data.candidateRole,
    miles: data.miles,
    search: data.search,
    page: data.currentPage,
    sortByColumn: data.sortByColumn,
    sortByOrder: data.sortByOrder,
  };

  systemAllRequests({
    request: postData,
    page: "applied",
    route: "get_applied_candidate_list",
  });

  const request = {
    endPoint: serviceRouteConstants.appliedCandidate,
    data: postData,
  };
  return await post(request);
};
/**
 * Asynchronously gets the applied shifts using the provided data.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} The result of the post request
 */
export const _getAppliedShifts = async (data) => {
  const { candidate_id, contract_id } = data;
  let postData = {
    contract_id: contract_id,
    candidate_id: candidate_id,
  };
  const request = {
    endPoint: serviceRouteConstants.appliedCandidateShifts,
    data: postData,
  };
  return await post(request);
};
// applied

/**
 * Asynchronously gets worked candidates data.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} The result of the asynchronous post request
 */
export const _getWorkedCandidates = async (data) => {
  let candidateId = data.candidateId;
  let candidateRefNo = data.candidateReferenceNo;
  let contractRefNo = data.contractReferenceNo;
  let licenceNo = data.candidateLicenseNo;
  let complianceStatus = data.complianceStatus;
  let role = data.candidateRole;
  let postcode = data.candidatePostcode;
  let sessionType = data.sessionType;
  let workedDateFrom = data.workedDateFrom;
  let workedDateTo = data.workedDateTo;
  let contractDateFrom = data.contractDateFrom;
  let contractDateTo = data.contractDateTo;
  let miles = data.miles;
  let search = data.search;
  let currentPage = data.currentPage;
  let timesheetStatus = data.timeSheetStatus;
  let listView = data.listView;
  let actionedById = data.actionedById;
  let actionedByType = data.actionedByType;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;

  if (candidateId && (candidateId !== "" || candidateId.length > 0)) {
    candidateId = candidateId.join(",");
  }

  if (sessionType && (sessionType !== "" || sessionType.length > 0)) {
    sessionType = sessionType.join(",");
  }

  if (workedDateFrom && workedDateFrom !== "") {
    workedDateFrom = workedDateFrom.split("/").reverse().join("-");
  }

  if (workedDateTo && workedDateTo !== "") {
    workedDateTo = workedDateTo.split("/").reverse().join("-");
  }

  if (contractDateFrom && contractDateFrom !== "") {
    contractDateFrom = contractDateFrom.split("/").reverse().join("-");
  }

  if (contractDateTo && contractDateTo !== "") {
    contractDateTo = contractDateTo.split("/").reverse().join("-");
  }

  if (
    timesheetStatus &&
    (timesheetStatus !== "" || timesheetStatus.length > 0)
  ) {
    timesheetStatus = timesheetStatus.join(",");
  }

  let postData = {
    candidate_id: candidateId,
    candidate_reference_no: candidateRefNo,
    contract_reference_no: contractRefNo,
    licence_no: licenceNo,
    candidate_compliance_status: complianceStatus,
    role: role,
    postcode: postcode,
    sessionType: sessionType,
    last_worked_date_from: workedDateFrom,
    last_worked_date_to: workedDateTo,
    contract_date_from: contractDateFrom,
    contract_date_to: contractDateTo,
    miles: miles,
    search: search,
    page: currentPage,
    timesheet_status: timesheetStatus,
    isView: listView,
    actioned_by_id: actionedById,
    actioned_by_type: actionedByType,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
  };

  systemAllRequests({
    request: postData,
    page: "worked",
    route: "get_worked_candidate_list",
  });

  const request = {
    endPoint: serviceRouteConstants.workedCandidate,
    data: postData,
  };
  return await post(request);
};

export const _getWorkedShifts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.workedShifts,
    data: {
      contract_id: data.contractId,
    },
  };
  return await post(request);
};
// worked

/**
 * Asynchronous function to get booked candidates.
 *
 * @param {Object} data - The data to be sent in the request
 * @return {Promise} The result of the POST request
 */
export const _getBookedCandidates = async (data) => {
  let candidateId = data.candidateId;
  let complianceStatus = data.complianceStatus;
  let bookedDateFrom = data.bookedDateFrom;
  let bookedDateTo = data.bookedDateTo;
  let postcode = data.postcode;
  let sessionType = data.sessionType;
  let candidateRefNo = data.candidateReferenceNo;
  let contractRefNo = data.contractReferenceNo;
  let licenceNo = data.licenceNo;
  let role = data.candidateRole;
  let miles = data.miles;
  let search = data.search;
  let currentPage = data.currentPage;
  let listView = data.listView;
  let sortByColumn = data.sortByColumn;
  let sortByOrder = data.sortByOrder;
  let for_upcomming = data.for_upcomming;

  if (candidateId && (candidateId !== "" || candidateId.length > 0)) {
    candidateId = candidateId.join(",");
  }
  if (sessionType && (sessionType !== "" || sessionType.length > 0)) {
    sessionType = sessionType.join(",");
  }
  if (bookedDateFrom && bookedDateFrom !== "") {
    bookedDateFrom = bookedDateFrom.split("/").reverse().join("-");
  }
  if (bookedDateTo && bookedDateTo !== "") {
    bookedDateTo = bookedDateTo.split("/").reverse().join("-");
  }

  let postData = {
    candidate_id: candidateId,
    candidate_compliance_status: complianceStatus,
    booked_date_from: bookedDateFrom,
    booked_date_to: bookedDateTo,
    postcode: postcode,
    sessionType: sessionType,
    candidate_reference_no: candidateRefNo,
    contract_reference_no: contractRefNo,
    licence_no: licenceNo,
    role: role,
    miles: miles,
    search: search,
    page: currentPage,
    isView: listView,
    sortByColumn: sortByColumn,
    sortByOrder: sortByOrder,
    for_upcomming: for_upcomming ? 1 : 0,
  };

  systemAllRequests({
    request: postData,
    page: "booked",
    route: "get_booked_candidate_list",
  });

  const request = {
    endPoint: serviceRouteConstants.bookedCandidate,
    data: postData,
  };
  return await post(request);
};

export const _getBookedShifts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.bookedShifts,
    data: {
      contract_id: data.contractId,
    },
  };
  return await post(request);
};
// booked

export const _getBookedMergeContractShifts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.bookedMergeContractShifts,
    data: {
      contract_id: data.contractId,
    },
  };
  return await post(request);
};

export const _getBookedSelectedMergeContractShifts = async (data) => {
  // console.log("data",data);
  // return;
  const request = {
    endPoint: serviceRouteConstants.bookedSelectedMergeContract,
    data: {
      contract_ids: data.contract_ids,
    },
  };
  return await post(request);
};

/**
 * Approve or reject a candidate.
 *
 * @param {Object} data - The data to be sent with the request
 * @return {Promise} A promise that resolves with the response data
 */
export const _approveCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.approveCandidate,
    data: data,
  };
  return await post(request);
};
export const _rejectCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.rejectCandidate,
    data: data,
  };
  return await post(request);
};
export const _approveSelectedShifts = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.approveSelectedShifts,
    data: data,
  };
  return await post(request);
};
// appove reject candidate

/**
 * Asynchronously fetches filter data using the provided data.
 *
 * @param {Object} data - The data to be used for fetching filter data.
 * @return {Promise} The promise containing the result of the filter data fetch.
 */
export const _fetchFilterData = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getFilterData,
    data: data,
  };
  return await post(request);
};
// get filter data
